import { ButtonProps } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import SegmentStore from '../../../../../SegmentStore';
import { AdvanceButton } from '../../Common';

interface Props extends ButtonProps {
  store: SegmentStore;
}

function ReadyButton({ store, ...others }: PropsWithChildren<Props>) {
  switch (store.state.kind) {
    case 'ready':
    case 'processing-request':
    case 'schedule-session':
      return <AdvanceButton {...others} onClick={store.previousAdvance} />;
    case 'advancing':
    case 'advancing-to':
    case 'completing':
    case 'completing-and-advancing':
    case 'reporting-results':
    case 'submitting-and-advancing':
    case 'previous-advancing':
    case 'quiz-failed':
    case 'loaded':
    case 'loading':
    case 'error':
    case 'waiting':
      return <AdvanceButton {...others} disabled />;
  }
}

export default observer(ReadyButton);
